import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4V4c0-1.1-.9-2-2-2zm0 15.17L18.83 16H4V4h16v13.17z"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M4 4v12h14.83L20 17.17V4z",
  opacity: ".3"
}, "1")], 'ModeCommentTwoTone');